import React, { memo, useCallback, useMemo } from "react";

import { withRouter } from "react-router-dom";
import { useTheme, useMediaQuery } from "@material-ui/core";
import { ReactComponent as Logo } from "../../shared/assets/images/logo.svg";
import { ReactComponent as BurgerSvg } from "../../shared/assets/images/burger.svg";

import classNames from "classnames";
import { Link, useLocation, matchPath } from "react-router-dom";

import styles from "./Header.module.scss";
import { ActionIcon, Avatar } from "@mantine/core";

import { menuItems } from "../../consts/menuItems";


import { useTranslation } from "react-i18next";

import AppActionsMenu from "./components/AppActionsMenu";

import clsx from "clsx";

import { openContextModal } from "@mantine/modals";
import LoginButton from "../../widgets/LoginButton";
import { useClientSession } from "../../shared/lib/clientSession";
import ClientMenu from "./components/ClientMenu";

const DESKTOP_NAV = [
  { label: "videoLibrary", path: "/library" },
  { label: "submitVideo", path: "/submitVideo", accent: true },
  { label: "ugcProduction", path: "/ugc-production" },
  { label: "forMedia", path: "/for-media" },
  { label: "aboutUs", path: "/aboutUs" },
  { label: "contactUs", path: "/contactUs" },
];

const Header = memo(({ currentUser, setCurrentUser, randomAvatar }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const client = useClientSession();

  const isCustomAgreementPage = useMemo(() => {
    return !!(
      matchPath(pathname, {
        path: "/submitVideo/:name",
        exact: true,
      }) ||
      matchPath(pathname, {
        path: "/submitVideos/:refHash",
        exact: true,
      })
    );
  }, [pathname]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Desktop nav as in the design: no "Home" (the logo links home),
  // "Submit video" as a pink pill, the current page highlighted
  const desktopItems = useMemo(
    () =>
      DESKTOP_NAV.filter((el) => !(isCustomAgreementPage && el.path === "/submitVideo")),
    [isCustomAgreementPage]
  );

  const filteredMenuItems = useMemo(() => {
    return menuItems.filter((el) => {
      if (isCustomAgreementPage) {
        return el.path !== "/submitVideo";
      }

      return el.path !== pathname;
    });
  }, [menuItems, isCustomAgreementPage, pathname]);

  const onOpenMobileMenu = useCallback(() => {
    openContextModal({
      modal: "mobileMenuModal",
      fullScreen: true,
      radius: 0,
      transitionProps: { transition: "slide-left", duration: 500 },
      title: !!currentUser ? (
        <Avatar
          size="md"
          src={!!currentUser.avatarUrl ? currentUser.avatarUrl : randomAvatar}
          radius="xl"
        />
      ) : null,
      innerProps: {
        currentUser,
        setCurrentUser,
        randomAvatar,
      },
      closeButtonProps: { size: "30px" },
    });
  }, [currentUser, setCurrentUser]);

  return (
    <header className={styles.header}>
      <div className={clsx(["container", styles.flexContainer])}>
        <div className={styles.headerLeftBlock}>
          <Link to="/">
            <Logo className={classNames("logo", styles.logo)} />
          </Link>
        </div>

        <div className={styles.headerCenterBlock}>
          {desktopItems.map(({ label, path, accent }) => (
            <Link
              key={path}
              to={path}
              className={clsx(
                accent && styles.navAccent,
                (pathname === path || (path !== "/" && pathname.startsWith(`${path}/`))) && styles.navActive
              )}
            >
              {t(label)}
            </Link>
          ))}
        </div>

        <div className={styles.headerRightBlock}>
          {/* page tools (researcher workspace: background, notifications) */}
          <div id="vb-header-tools" className={styles.headerTools} />
          {isMobile && (
            <ActionIcon
              onClick={onOpenMobileMenu}
              className={styles.burgerAction}
            >
              <BurgerSvg />
            </ActionIcon>
          )}
          {/* Client (media company) member: name + initials → account */}
          {!isMobile && !currentUser && client.signedIn && (
            <ClientMenu client={client} />
          )}
          {!isMobile && !currentUser && !client.signedIn && pathname !== "/login" && (
            <LoginButton className="header" />
          )}
          {!isMobile && currentUser && (
            <AppActionsMenu
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              randomAvatar={randomAvatar}
            />
          )}
        </div>
      </div>
    </header>
  );
});

export default withRouter(Header);

{
  /* <LanguagesMenu
        options={[
          { value: "en", label: "En" },
          { value: "cn", label: "Ch" },
        ]}
      /> */
}

{
  /* {isMobile && (
        <div className={styles.footer_links}>
          <Link to={"/contactUs"} className={styles.contact_us_link}>
            {t("contactUs")}
          </Link>
          <Link
            to="#"
            onClick={(e) => {
              window.location.href = "mailto:Licensing@vbear.media";
              e.preventDefault();
            }}
          >
            Licensing@vbear.media
          </Link>
          <div className={styles.social_links}>
            <a href="https://www.instagram.com/viralbearr" target="_blank">
              <IconButton className={styles.link}>
                <InstagramIcon fontSize="large" />
              </IconButton>
            </a>
            <a href="https://www.youtube.com/@viralbearrrr" target="_blank">
              <IconButton className={styles.link}>
                <YoutubeIcon fontSize="large" />
              </IconButton>
            </a>
          </div>
        </div>
      )}
     */
}
